import React from "react";

function useDelays() {
  const [areDelaysToggled, setAreDelaysToggled] = React.useState(false);

  return {
    areDelaysToggled,
    toggleDelays: () => setAreDelaysToggled((isToggled) => !isToggled),
  };
}

export { useDelays };
